import i18next from "i18next";
import React, { Component } from "react"
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { COLUMN_CODE, TableManger, TABLES } from "../../managers/TableManger";
import DataGridHolderPayroll from "../common/DataGridHolderPayroll";
import { EmployeePaymentListColumnConfig, parseColumnConfig, parseVisibleColumnConfig } from "../configs/config";
import { DKLabel, DKLine,showAlert, DKIcon, TOAST_TYPE, DKButton, DKInput, showToast, showLoader, removeLoader, INPUT_VIEW_DIRECTION} from "deskera-ui-library";
import FormatCurrencyService from "../../services/FormatCurrencyService";
import  {MAKE_PAYMENT_FORM_SG, MAKE_PAYMENT_FORM_MY, MANDATORY_FIELDS, GIRO_TYPE}  from "./GiroConstant";
import Utility, { deepClone } from "../../utility/Utility";
import GiroService from "../../services/GiroService";
import moment from "moment";
import CompanyDetailService from "../../services/CompanyDetailService";
import { ACCOUNT_TYPE, CONSTANTS, DATE_FORMAT, FILE_TYPE, FORMAT } from "../../constants/Constant";
import { getFileNameFromContentDisposition, getTenantCountryCode, isMYCompliance, isSGCompliance, downloadAsZip } from "../../managers/common/CommonUtil";
import { saveAs } from 'file-saver';
import EmployeeListService from "../../services/EmployeeListService";
import { COUNTRY } from "../../constants/CountryConstant";
import UserManager from "../../managers/UserManager";
import TenantManager from "../../managers/TenantManager";
import { connect } from "rxjs";
import TaxService from "../../services/compliance/TaxSerivce";
import {fetchCPFAccount } from "../../Redux/Slices/EmployeeListSlice";
import AddEpfAccount from "../AddEpfAccount";
import GIROSummary from "./giroSummarySection";
import { MODULE } from "../user-permissions/PermissionUtils";

export default class MakePayment extends Component {
    gridContainer = React.createRef();
    timeout
    grid = {
        gridActions: {
            filters: [],
            currentPage: 1,
            totalPageCount: 1
        },
        gridData: {
            
            columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_GIRO_EMPLOYEE), TABLES.PEOPLE_GIRO_EMPLOYEE, {})),
            rowData: [],
            filter: [],
            originalData: []
        },
        
    }
    canValidate = false
    giroFormVales = {
        "bank":"",
        "accountNumber":"",
        "payDate":"",
        "status":{id:"",name:"All"},
        "employeeIds":[],
        "payrunId":"",
        "companyCode":"",
        "branchCode":"",
        "fileFormat":"",
        "bankCode":"",
        "recipientReference":""
    }
    giroFormFields = getTenantCountryCode() === COUNTRY.SG ? MAKE_PAYMENT_FORM_SG :MAKE_PAYMENT_FORM_MY
    bankListOption = [];
    bankList = []
    accountNumberOption = [];
    paymentDetials = {};
    myTaxData = {
        compliance: {
            "@type": "type.googleapis.com/v1.MYTaxDetails",
            companyTaxNumber: "",
            eisNumber: "",
            empTaxNumber: "",
            hrdfNumber: "",
            registrationNumber: "",
            socsoNumber: "",
            zakatNumber: "",
            stateCode:""
        }       
    };
    epfAccounts = {};
    enableAddEpf = false;
    selectedRecords = [];
    refresh = false;
    summaryData = {
        giroAmount: 0,
        selectedEmployee: 0,
        totalNetPay: 0
    }
    constructor(props) {
        super(props)
        RouteManager.setPresenter(this);
        if(!Utility.isEmpty(GiroService.MakePaymentValues?.payrunId)) {
            
            this.giroFormVales.payDate = new Date(GiroService.MakePaymentValues.firstPayDate);
            this.giroFormVales.payrunId = GiroService.MakePaymentValues.payrunId;
            if(isMYCompliance()) {
                this.giroFormVales["autoGenerate"] = true;
                this.giroFormFields = this.giroFormFields.filter(field=>field.key!='batchId');
                this.giroFormVales["giroType"] = {id:"salary", name:"Salary Giro"};
            } else {
                this.giroFormVales["batchId"] = null;
            }
        } else {
            RouteManager.navigateToPage('')
        }
        this.state = {
            gridWidth:950,
            giroAmount:0,
            selectedEmployee:0,
            totalNetPay:0
        }

        window.navigateToPage = (url) => {
            document.getElementById("dk-alert-background")?.remove();
            document.getElementById("dk-alert")?.remove();
            switch (url) {
                case PAGE_ROUTES.ADD_EPF_ACCOUNT:
                    this.onEPFopUpOpen();
                    break;            
                default:
                    RouteManager.navigateToPage(url);
                    break;
            }
            
        }

    }
    componentDidMount() {
        this.getCpfEpfAccountDetails();
        this.getTaxDetails();
        this.getPaymentDetails()
        this.getBankList()
        this.setState({
            gridWidth: (this.gridContainer?.current?.clientWidth || 950)
        })
    }
    componentWillUnmount() {
        if(this.timeout) {
            clearInterval(this.timeout)
        }
    }
    updateState() {
        this.setState({...this.state})
    }
    getBankList() {
        CompanyDetailService.getBankDetail({accountType:ACCOUNT_TYPE.GIRO}).then(res=>{
            this.bankListOption = [];
            this.bankList = [];
            if(res && res.bankAccounts) {
                this.bankList = res.bankAccounts.map(acc=> {acc['name']= acc['bank']; return acc})
                this.bankListOption = this.bankList.filter(
                    (bank, i, arr) => arr.findIndex(t => t.key === bank.key) === i
                  );                
                let bankInd = this.giroFormFields.findIndex(field=>field.columnCode ==='bank');
                this.giroFormFields[bankInd].options = this.bankListOption;
                this.updateState()
            }
        })
    }
    getPaymentDetails() {
        let param = {
            payrunId:this.giroFormVales.payrunId,
            limit:20,
            page:1,
            generated: this.giroFormVales['status'].id
        }
        GiroService.getPaymentDetails(param).then(res=>{
            console.log(res)
            if(res) {
                this.paymentDetials = res;
                this.grid.gridData.rowData = EmployeePaymentListColumnConfig(res.giroEmployeeDetails)
                this.selection = [];
                this.summaryData = {
                    totalNetPay: res.totalPayment,
                    selectedEmployee: this.selection.length,
                    giroAmount:0
                }
                this.setState({
                    totalNetPay: res.totalPayment,
                    selectedEmployee: this.selection.length,
                    giroAmount:0
                })
            }
        })
    }
    generatGIRO() {
        let isValid = true;
        this.giroFormFields.map(field=>{
            if(field.required&&((!field.isValid) ||(Utility.isEmpty(this.giroFormVales[field.columnCode])))) {
                this.canValidate = true;
                this.updateState()
                isValid = false
                return;
            }
        })
        if(!isValid) {
            return
        }
        if(this.state.selectedEmployee == 0 && this.summaryData.selectedEmployee == 0) {
            showToast("Please select employee.")
            return;
        }
        if(!this.isMandatoryFieldPresent()) {
            return;
        }
        const employeeId = [];
        let isAlreadyGenerated = false;
        this.selection.map(t => t).reduce((acc, value) => {
            employeeId.push(value.data.employeeId);
            if (value.data.giroGenerated) {
                isAlreadyGenerated = true;
            }
        }, 0);
        if(isAlreadyGenerated) {
            const buttons = [
                {
                  title: "No",
                  className: "bg-gray1 border-m",
                },
                {
                  title: "Yes",
                  className: "bg-red text-white ml-r",
                  onClick: () => {
                    this.saveGIRO(employeeId)
                    
                  },
                },
              ];
          
              showAlert(
                "Generate GIRO again?",
                "GIRO is already generated for selected employees. Do you want to continue for generate GIRO?",
                buttons
              );
        } else {
            this.saveGIRO(employeeId)
        }
    }
    saveGIRO(employeeId) {
        this.giroFormVales['employeeIds'] = employeeId;
        let param = {
            ...this.giroFormVales,
            bank: this.giroFormVales.bank.bank.split(' ').join(''),
            accountNumber: this.giroFormVales.accountNumber.accountNumber,
            status: this.giroFormVales.status.id,
            payDate: this.giroFormVales.payDate ? moment(this.giroFormVales.payDate,FORMAT.MMDDYYYY_2).format(FORMAT.YYYYMMDD):'',
            branchCode: this.giroFormVales.bank.branchCode,
            format:  this.getFileFormat(this.giroFormVales.bank.bank.split(' ').join(''))
        }
        if(isSGCompliance() && this.giroFormVales.batchId) {
            param['batchId'] = parseFloat(this.giroFormVales.batchId)
            param["giroType"] = "salary";
        } else {
            const giroType = EmployeeListService.getSelectedIdFromObject(this.giroFormVales.giroType, "id");
            param["giroType"] = giroType;
            param["statutoryType"] = !Utility.isEmpty(giroType) && giroType === "statutory"  ? EmployeeListService.getSelectedIdFromObject(this.giroFormVales.statutoryType, "id") : CONSTANTS.EMPTY_STRING;
            param["bankCode"] = this.giroFormVales.bankCode;
            param["contactName"] = UserManager.getUserName();
            param['recipientReference'] = this.giroFormVales.recipientReference;
        }
        showLoader()
        if(param["giroType"] === "salary" && param["bank"] === "MayBank(2E)") {
            this.generateGiroForMaybank(param);
        } else {
            if(!Utility.isEmpty(param["format"]) && param["format"] === ".xls" || param["format"] === ".xlsx") {
                GiroService.generateGIROXLS(param).then(response => {
                    removeLoader()
                    if (response) {
                        showToast("GIRO file generated successfully. You can view all the generated files under Payment Logs in settings",TOAST_TYPE.SUCCESS)
                        let fileName = this.getFileName(this.getFileType(param["format"]));
                        saveAs(response, fileName);
                        this.getPaymentDetails()
                        setTimeout(()=> {
                            RouteManager.navigateToPage(GiroService.MakePaymentValues.backRout)
                        },7000);
                        this.refresh = true;
                    }
                },error=>{
                    removeLoader()
                    if (error.code == 200) {
           
                      } else if (error.code == 400) {
                        this.errorHandlerForGenerateGiro(error);
                      } else if (error.code == 500) {
                        showToast(error.errorMessage,TOAST_TYPE.FAILURE)
                      } else {
                        showToast("Not able to get employee from server.",TOAST_TYPE.FAILURE)
                      }
                      this.refresh = true;
                })
            } else {
                GiroService.generateGIRO(param).then(response => {
                    removeLoader()
                    if (response) {
                        showToast("GIRO file generated successfully. You can view all the generated files under Payment Logs in settings",TOAST_TYPE.SUCCESS)
                        let fileName = this.getFileName(FILE_TYPE.TXT);
                        response = new Blob([response], {type : 'application/text'});
                        saveAs(response, fileName);
                        this.getPaymentDetails()
                        setTimeout(()=> {
                            RouteManager.navigateToPage(GiroService.MakePaymentValues.backRout)
                        },7000);
                        this.refresh = true;
                    }
                },error=>{
                    removeLoader()
                    if (error.code == 200) {
           
                      } else if (error.code == 400) {
                        this.errorHandlerForGenerateGiro(error);
                      } else if (error.code == 500) {
                        showToast(error.errorMessage,TOAST_TYPE.FAILURE)
                      } else {
                        showToast("Not able to get employee from server.",TOAST_TYPE.FAILURE)
                      }
                      this.refresh = true;
                })
            }
            
        }
    }

    getFileType = (format) => {
        switch (format) {
            case ".xls":
                return FILE_TYPE.XLS;
            case ".xlsx":
                return FILE_TYPE.XLSX;
            default:
                break;
        }
    }

    errorHandlerForGenerateGiro(error) {
        const date = this.giroFormVales.payDate ? moment(this.giroFormVales.payDate,FORMAT.MMDDYYYY_2).format(FORMAT.YYYYMMDD):'';
        const batchId = !isMYCompliance() ? this.giroFormVales.batchId:'';
        let errorMsg =''
        if(!isMYCompliance()) {
            errorMsg = 'Batch ID' + ' ' + batchId + ' ' 
        }
        errorMsg += 'already exists for date' + ' ' + date;
        showAlert('Error',errorMsg, [
            {
              title: "Close",
              className: "bg-gray1 border-m "
            }
          ])
      }



    generateGiroForMaybank(params) {
        const salaryGiroParams = deepClone(params);
        let adviceGiroParams = params;
        adviceGiroParams["giroType"] = "advice";
        Promise.all([GiroService.generateGIRO(salaryGiroParams), GiroService.generateGIRO(adviceGiroParams)]).then(
            (response) => {
                removeLoader()
                if (response[0] && response[1]) {
                    showToast("GIRO file generated successfully. You can view all the generated files under Payment Logs in settings",TOAST_TYPE.SUCCESS)
                    const paymentFileName = this.getFileNameWithType("PAYMENT", FILE_TYPE.TXT);
                    const adviceFileName = this.getFileNameWithType("ADVICE", FILE_TYPE.TXT);
                    const paymentFile = new File([response[0]], paymentFileName);
                    const adviceFile = new File([response[1]], adviceFileName);
                    downloadAsZip([paymentFile,adviceFile], "MayBank2E");

                    // response = new Blob([response], {type : 'application/text'});
                    // saveAs(response, fileName);
                    this.getPaymentDetails()
                    setTimeout(()=> {
                        RouteManager.navigateToPage(GiroService.MakePaymentValues.backRout)
                    },5000)
                }
            },error=>{
                removeLoader()
                if (error.code == 200) {       
                  } else if (error.code == 400) {
                    this.errorHandlerForGenerateGiro(error);
                  } else if (error.code == 500) {
                    showToast(error.errorMessage,TOAST_TYPE.FAILURE)
                  } else {
                    showToast("Not able to get employee from server.",TOAST_TYPE.FAILURE)
                  }
            }
        )
    }

    getFileName(fileType) {
        const date = moment(this.giroFormVales.payDate,FORMAT.MMDDYYYY_2).format(FORMAT.YYYYMMDD);
        const bank = this.giroFormVales.bank.bank.split(' ').join('');
        if(!isMYCompliance()) {
          const batchId = this.giroFormVales.batchId; // need to handle
          return bank + '_' + date + '_' + batchId + `.${FILE_TYPE.TXT}`;
        } else {
          return bank + '_' + date + `.${fileType}`;
        }
      }
      
    getFileNameWithType(type, fileType) {
        const date = moment(this.giroFormVales.payDate,FORMAT.MMDDYYYY_2).format(FORMAT.YYYYMMDD);
        const bank = this.giroFormVales.bank.bank.split(' ').join('');
        return bank + '_' + '_' + type + '_' + date + `.${fileType}`;
    }

    getFieldValue(obj) {
        switch (obj.columnCode) {
            case COLUMN_CODE.PEOPLE_GIRO.PAY_DATE:
                if (this.giroFormVales[obj.columnCode]) {
                    return new Date(this.giroFormVales[obj.columnCode]);
                } else {
                    this.giroFormVales[obj.columnCode] = moment(new Date()).format('YYYY-MM-DD');
                    return new Date();
                }
            default:
                return this.giroFormVales[obj.columnCode]
        }

    }
    onChange(value, index, obj) {
        switch (obj.key) {
            case 'status':
                this.giroFormVales[obj.key] = value;
                this.getPaymentDetails();
                break;
            case 'bank':
                this.bankAccounts = deepClone(this.bankList.filter(bl=>bl.key==value.key))
                let bankInd = this.giroFormFields.findIndex(field=>field.columnCode ==='accountNumber');
                this.giroFormFields[bankInd].options = this.bankAccounts.map(ba=>{ba['name']=ba['accountNumber']; return ba});
                this.giroFormVales['accountNumber'] = null;
                this.giroFormVales[obj.key] = value;
                this.giroFormVales["companyCode"] = value?.companyCode;
                this.checkAndUpdateReferenceField(this.giroFormFields);
                this.updateState();
            case 'giroType':
                const giroType = EmployeeListService.getSelectedIdFromObject(value, "id");
                const alteredConfig = [];
                if(giroType === "statutory") {
                    alteredConfig.push({columnCode:"statutoryType", uiVisible:true, required: true});
                    EmployeeListService.getAlteredConfigDetails(this.giroFormFields,alteredConfig,false, {},{});
                } else {
                    this.giroFormVales["statutoryType"] = CONSTANTS.EMPTY_STRING;
                    alteredConfig.push({columnCode:"statutoryType", uiVisible:false, required: false});
                    EmployeeListService.getAlteredConfigDetails(this.giroFormFields,alteredConfig,false, {},{});
                }
                this.giroFormVales[obj.key] = value;
                this.checkAndUpdateReferenceField(this.giroFormFields);
                this.updateState();
                break;
            default:
                this.giroFormVales[obj.key] = value;
                break;
        }
    }

    checkAndUpdateReferenceField = (formFields) => {
        const bank = this.giroFormVales.bank?.bank?.split(' ').join('');
        const giroType = EmployeeListService.getSelectedIdFromObject(this.giroFormVales.giroType, "id");
        const alteredConfig = [];
        switch (bank) {
            case "HongLeongBank":
                switch (giroType) {
                    case "statutory":
                        alteredConfig.push({columnCode:"recipientReference", uiVisible : false, required:false});
                        alteredConfig.push({columnCode:"fileFormat", uiVisible : true, required:true});
                        alteredConfig.push({columnCode:"giroType", options:GIRO_TYPE, uiVisible : true, required:true});
                        break;
                
                    default:
                        alteredConfig.push({columnCode:"recipientReference",name:"Recipient Reference", uiVisible : true, required:true});
                        alteredConfig.push({columnCode:"fileFormat", uiVisible : true, required:true});
                        alteredConfig.push({columnCode:"giroType", options:GIRO_TYPE, uiVisible : true, required:true});
                        break;
                }   
                break;
            case "StandardCharteredBank":
                const salaryOptions = GIRO_TYPE.filter((t) => t.id === "salary").map((m) => {return m});
                alteredConfig.push({columnCode:"recipientReference", uiVisible : false, required:false});
                alteredConfig.push({columnCode:"fileFormat", uiVisible : false, required:false});
                    alteredConfig.push({columnCode:"giroType", options:salaryOptions, uiVisible : true, required:true});
                    this.giroFormVales["fileFormat"] = {};
                    const fieldTypeGiro = EmployeeListService.getSelectedIdFromObject(this.giroFormVales["giroType"], "id");
                    if(!Utility.isEmpty(fieldTypeGiro) && !salaryOptions.some((s) => s.id === fieldTypeGiro)) {
                        this.giroFormVales["giroType"] = {};
                    }
                    break;
            case "BANKISLAM":
                const options = GIRO_TYPE.filter((t) => t.id === "salary").map((m) => {return m});
                    alteredConfig.push({columnCode:"recipientReference", name: "Payment Details", uiVisible : true, required:true});
                    alteredConfig.push({columnCode:"fileFormat", uiVisible : false, required:false});
                    alteredConfig.push({columnCode:"giroType", options:options, uiVisible : true, required:true});
                    this.giroFormVales["fileFormat"] = {};
                    const fieldType = EmployeeListService.getSelectedIdFromObject(this.giroFormVales["giroType"], "id");
                    if(!Utility.isEmpty(fieldType) && !options.some((s) => s.id === fieldType)) {
                        this.giroFormVales["giroType"] = {};
                    }
                    break;        
            default:
                alteredConfig.push({columnCode:"recipientReference", uiVisible : false, required:false});
                alteredConfig.push({columnCode:"fileFormat", uiVisible : false, required:false});
                alteredConfig.push({columnCode:"giroType", options:GIRO_TYPE, uiVisible : true, required:true});
                break;
        }
        this.updateBankRelatedGridColumns(bank);
        EmployeeListService.getAlteredConfigDetails(formFields, alteredConfig, false, {}, {});
    }

    checkAndUpdateFieldBasedOnStatutoryType = (formFields, statutoryType) => {
        const alteredConfig = [];
        switch (statutoryType) {
            case "statutory":
                alteredConfig.push({columnCode:"recipientReference", uiVisible : true, required:true});
                break;
        
            default:
                alteredConfig.push({columnCode:"recipientReference", uiVisible : false, required:false});
                break;
        }
        EmployeeListService.getAlteredConfigDetails(formFields, alteredConfig, false, {}, {});
    }
    
    isMandatoryFieldPresent = () => {
        let isFieldsPresent = true;
        const giroType = EmployeeListService.getSelectedIdFromObject(this.giroFormVales.giroType, "id");
        const statutoryType = !Utility.isEmpty(giroType) && giroType === "statutory"  ? EmployeeListService.getSelectedIdFromObject(this.giroFormVales.statutoryType, "id") : CONSTANTS.EMPTY_STRING;
        const bank = this.giroFormVales.bank.bank.split(' ').join('');
        const requiredFields = [];

        const fields = MANDATORY_FIELDS[`${bank}_${giroType}_${statutoryType}`];
        fields?.forEach(field => {
            switch (field) {
                case "Tax Details":
                    if(Utility.isEmptyObject(this.myTaxData?.compliance) || Utility.isEmpty(this.myTaxData.compliance.stateCode)) {
                        requiredFields.push({field: "Tax Details", url: PAGE_ROUTES.MY_TAX_DETAILS});
                        isFieldsPresent = false;
                    }
                    
                    break;
                case "EPF Account":
                    if(this.epfAccounts.length === 0) {
                        requiredFields.push({field: "Add EPF Account", url: PAGE_ROUTES.ADD_EPF_ACCOUNT});
                        isFieldsPresent = false;
                    }
                    break;
                case "Company Number":
                    const tenantData = TenantManager.getPeopleTenantData();
                    if(Utility.isEmpty(tenantData?.tenant?.contactNumber)) {
                        requiredFields.push({field: "Company Contact Number", url: PAGE_ROUTES.COMPANY_DETAILS});
                        isFieldsPresent = false;
                    }
                    break;
            
                default:
                    break;
            } 
        });
        if(!isFieldsPresent) {
            const buttons = [
                {
                  title: "Ok",
                  className: "bg-red text-white ml-r"
                },
              ];
    
            showAlert(
                "Please fill below details before generating giro file",
                `<div class=''>${requiredFields.map((f,i) => `<div class='d-flex fs-s' style='justify-content:flex-start; padding-top:5px'><div class='fs-m cursor-hand' onclick=window.navigateToPage('${f.url}')><span class='fw-m'>${i + 1}.</span> <u class='text-app'>${f.field}</u></div></div>`).join('')}</div>`,
                buttons
              );
        }

        return isFieldsPresent;
    }

    getTaxDetails = () => {
        TaxService.getTaxDetail(getTenantCountryCode()).then(res=>{
            this.myTaxData = res;
        },error=>{}
        )
    }

    getCpfEpfAccountDetails = () => {
        if(Utility.isEmptyObject(this.epfAccounts)) {
            const config = {
              Limit: 100,
              currentPage: 1,
              order: undefined,
              field: undefined,
              searchString: undefined,
            };
            EmployeeListService.apiConfig = config;
            EmployeeListService.getCPFAAccounts().then((response) => {
                const accounts = response?.accounts?.length > 0 ? response.accounts : []
                this.epfAccounts = accounts;
            })
        }
    }

    onEPFopUpOpen = () => {
        this.enableAddEpf = true;
        this.updateState();
    }

    onEPFopUpClose = (value) => {
        this.enableAddEpf = false;
        this.updateState();
        if(value) {
            this.getCpfEpfAccountDetails();
        }
    }

    getFileFormat = (selectedBank) => {
        const fileFormat = EmployeeListService.getSelectedIdFromObject(this.giroFormVales.fileFormat, "id");
        switch (selectedBank) {
            case "HongLeongBank":
                return fileFormat;        
            default:
                return ".txt"
        }
    }

    updateBankRelatedGridColumns = (bankName) => {
        if(!Utility.isEmpty(bankName)) {
            const viewConfig = {
                bankName : bankName
            }
            console.log(TableManger.getTableVisibleColumns(TABLES.PEOPLE_GIRO_EMPLOYEE));
            this.grid.gridData.columnData = parseVisibleColumnConfig(parseColumnConfig(deepClone(TableManger.getTableVisibleColumns(TABLES.PEOPLE_GIRO_EMPLOYEE)), TABLES.PEOPLE_GIRO_EMPLOYEE, viewConfig));
            this.updateState();
        }        
    }

    getFormField = (obj, index) => {
        return (
            <>
                {obj.uiVisible && (
                    <DKInput
                        className={"p-v-s mb-l p-h-l"}
                        icon={obj.icon}
                        title={obj.name}
                        placeholder={obj.name}
                        value={this.getFieldValue(obj)}
                        options={obj.options}
                        type={obj.type}
                        errorMessage={obj.errorMessage}
                        labelClassName=" text-align-left "
                        canValidate={this.canValidate || obj.columnCode == 'payDate'}
                        onChange={(value) => {
                            this.onChange(value, index, obj);
                        }}
                        tooltip={{
                            content: obj.tooltipText,
                            className: "warning-tooltip-prop",
                        }}
                        validator={(value) => {
                            if (obj.validation && obj.validation.regExp) {
                                const regex = new RegExp(obj.validation.regExp);
                                obj.isValid = regex.test(value);
                                return regex.test(value);
                            } else if (obj.required && typeof value === "string" && Utility.isEmpty(value.trim())) {
                                obj.isValid = false
                                return false;
                            } else if (obj.required && Utility.isEmpty(value)) {
                                obj.isValid = false
                                return false;
                            } else if (obj.validation && obj.validation.range) {
                                if ( value <= obj.validation.range.max && (value <= obj.validation.range.max) && (value >= obj.validation.range.min) && obj.validation.range.maxLength >= value.length) {
                                    obj.isValid = true
                                    return true;
                                } else if(obj.validation.range.maxLength && obj.validation.range.maxLength >= value.length) {
                                    obj.isValid = true
                                    return true;
                                } else {
                                    obj.isValid = false
                                    return false;
                                }

                            } else if (obj.columnCode == 'payDate') {
                                let date = moment(value);
                                const day = date.day();
                                if (day == 0) {
                                    obj.isValid = false;
                                    return false
                                } else {
                                    obj.isValid = true;
                                    return true
                                }
                            } else if(obj.columnCode === "recipientReference") {
                                if ( obj.validation &&  value.length > obj.validation.range.maxLength) {
                                    obj.isValid = true
                                    return true;
                                } else {
                                    obj.isValid = false
                                    return false;
                                }
                            }
                            else {
                                obj.isValid = true;
                                return true;
                            }
                        }}
                        formatter={(obj) => {
                            /** How to render a selected option in case of object **/
                            return obj.name;
                        }}
                        dropdownConfig={{
                            className: "",
                            style: {},

                            data: obj.options,
                            renderer: (index, obj) => {
                                /** How to render value in Dropdown in case of object **/
                                return <DKLabel text={`${obj.name}`} />;
                            },
                            onSelect: (index, obj) => {

                            },
                        }}
                        direction={obj.direction}
                        required={obj.required}
                        readOnly={obj.readOnly}
                    />
                )}

            </>
        )
    }
    
    giroPaymentForm = () => {
        return (
            <div className="bg-white border-m border-radius-s pb-l">
                <DKLabel text="GIRO Payment" className="p-l fw-m" />
                <DKLine className="bg-gray3 mb-s" />
                <div className="d-flex flex-wrap">
                {
                    this.giroFormFields.map((field, index) => {
                        return (<>{field.uiVisible && <div className="web-width-50 ">{this.getFormField(field, index)}</div>}</>)
                    })
                }
                </div>
            </div>
        )
    }
    summary = () => {

    }
    onRowAdd = () => { }
    onRowDelete = () => { }
    onContextCancel = () => { }
    onRowClick = () => { }
    getAttendanceData = () => { }
    onSearch = () => { }
    onSelect = (selection) => {
        this.calculateTotal(selection);
    }
    calculateTotal = (selection) =>{
        this.selection = (selection);
        let totalAmount = 0;
        this.selection.forEach(emp=>{
            totalAmount += emp.data.netPay
        })
        this.refresh = false;
        this.summaryData = {
            ...this.summaryData,
            selectedEmployee: this.selection.length,
            giroAmount:totalAmount
        }
        this.refs.child.updateState(this.summaryData);
        
    }
    makePayment = (data) => { 
        console.log(data)
    }
    getEmployeeDetail = () => {
        return (
            <div className="column parent-width flex-1 " ref={this.gridContainer}>
                <div className="column parent-width mb-s position-relative flex-1 ">
                    <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_GIRO_EMPLOYEE}
                        displayTableName={" "}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        allowRowAdd={false}
                        allowColumnSort={false}
                        refresh={false}
                        allowDataExport={false}
                        allowRowEdit={true}
                        showContextEdit={false}
                        isActionEnabled={true}
                        contextMenu={true}
                        isMenuVisible={true}
                        showContextMenu={true}
                        gridData={this.grid.gridData}
                        filter={this.grid.gridActions.filters}
                        currentPage={this.grid.gridActions.currentPage}
                        totalPageCount={this.grid.gridActions.totalPageCount}
                        addButtonConfig={[]}
                        onRowOpenBtnHidden={true}
                        onFilter={(dataList, queries) => {

                        }}
                        onRowUpdate={(data) => {
                            this.onRowUpdate(data);
                        }}
                        onRowDelete={(data) => {
                            this.onRowDelete(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {

                        }}
                        onSelection={(selection) => {
                            this.onSelect(selection)
                        }}
                        isActionEnabled={true}

                        allowBulkOperation={true}
                        dateFormat={this.dateFormat}

                        onCancelContext={() => {
                            this.onContextCancel();
                        }}
                        contextMenu={false}
                        onRowClick={(data) => {
                            this.onRowClick(data)
                        }}
                        onPaginationClick={(requestedPageNumber) => {
                            this.grid.gridActions.currentPage = requestedPageNumber
                            this.getAttendanceData()
                        }}
                        onSearch={(data) => this.onSearch(data)}
                        makePayment={this.makePayment}
                        gridWidth={this.state.gridWidth}
                        isActionEnabled={false}
                        onRowSelect={this.onRowSelect}
                        onAllRowSelect={this.onAllRowSelect}
                        addMenuButton={[]}
                        module={MODULE.GIRO}
                    />
                </div>
            </div>
        )
    }
    
    render() {
        return (
            <>
                <div className="row justify-content-between pb-l">
                    <DKLabel text="Make Payment" className="fw-m fs-l " />
                    <div className="d-flex">
                        <DKButton className="border-m bg-white" title="Cancel" onClick={()=>RouteManager.navigateToPage(GiroService.MakePaymentValues.backRout)} />
                        <DKButton className="bg-app text-white ml-l" title="Generate GIRO" onClick={()=>{this.generatGIRO()}}/>
                    </div>
                </div>
                <div className="row row-responsive ">
                    <div className="web-width-70 parent-height">
                        {this.giroPaymentForm()}
                        {this.getEmployeeDetail()}
                    </div>
                    <div className="web-width-30 p-l parent-height">
                        <GIROSummary ref={'child'} data={this.summaryData}/>
                    </div>
                </div>
                {this.enableAddEpf && (
                    <AddEpfAccount
                        isEdit={false}
                        onClose={(value) => this.onEPFopUpClose(value)}
                        details={{}}
                    />
                )}
            </>
        )
    }
}
